import {
  ActionReducerMapBuilder,
  createAsyncThunk,
  createSlice,
  PayloadAction,
  SerializedError,
} from '@reduxjs/toolkit'
// import { loadAuthors, modifyAuthor, removeAuthor, saveAuthor } from '../api/author'
// import { findCurrentTimePeriodAuthors } from '../utils/findCurrentTimePeriodAuthors'
// import { isWithinInterval } from 'date-fns'
// import { findAuthorsByDate } from '../utils/findAuthorsByDate'
import { Author, CreateAuthor } from '../types/author'
import { authorApi } from '../api/api'

// load all authors
export const loadAllAuthors = createAsyncThunk(
  'author/loadAllAuthors',
  async (_, thunkApi) => {
    try {
      return await authorApi.getAllAuthors()
    } catch (e) {
      return thunkApi.rejectWithValue('getAuthorsError')
    }
  },
)

// load author
export const loadAuthor = createAsyncThunk(
  'author/loadAuthor',
  async (id: string, thunkApi) => {
    try {
      return await authorApi.getAuthor(id)
    } catch (e) {
      return thunkApi.rejectWithValue('getAuthorsError')
    }
  },
)

// add author
export const addAuthor = createAsyncThunk(
  'author/addAuthor',
  async (author: CreateAuthor, thunkApi) => {
    try {
      return await authorApi.createAuthor(author)
    } catch (e) {
      return thunkApi.rejectWithValue('addAuthorError')
    }
  },
)

// // update author
// export const updateAuthor = createAsyncThunk(
//   'author/updateAuthor',
//   async (author: Author, thunkApi) => {
//     try {
//       return await modifyAuthor(author)
//     } catch (e) {
//       return thunkApi.rejectWithValue('updateAuthorError')
//     }
//   },
// )

// // delete objective
// export const deleteAuthor = createAsyncThunk(
//   'author/deleteAuthor',
//   async (id: string, thunkApi) => {
//     try {
//       return await removeAuthor(id)
//     } catch (e) {
//       return thunkApi.rejectWithValue('deleteAuthorError')
//     }
//   },
// )

interface AuthorSliceState {
  authors: Author[]
  author?: Author
  loading: boolean
  loadedAllAuthors: boolean
  error?: SerializedError
}

const initialState: AuthorSliceState = {
  authors: [],
  author: undefined,
  loading: false,
  loadedAllAuthors: false,
  error: undefined,
}

const authorSlice = createSlice({
  name: 'author',
  initialState,
  reducers: {
    setAuthor: (
      state: AuthorSliceState,
      action: PayloadAction<Author | undefined>,
    ) => {
      state.author = action.payload
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<any>) => {
    // get all authors
    // @ts-ignore
    builder.addCase(
      loadAllAuthors.fulfilled,
      (state: AuthorSliceState, action: PayloadAction<Author[]>) => {
        state.authors = action.payload?.sort((a, b) =>
          a.name.eng.localeCompare(b.name.eng),
        )
        state.loadedAllAuthors = true
        state.error = undefined
      },
    )

    builder.addCase(
      loadAllAuthors.pending,
      (state: AuthorSliceState, action) => {
        state.loadedAllAuthors = true
        state.error = undefined
      },
    )

    builder.addCase(loadAllAuthors.rejected, (state, action) => {
      state.loadedAllAuthors = true
      state.error = action.payload
    })

    // get author
    // @ts-ignore
    builder.addCase(
      loadAuthor.fulfilled,
      (state: AuthorSliceState, action: PayloadAction<Author>) => {
        state.author = action.payload
        state.loadedAllAuthors = true
        state.error = undefined
      },
    )

    builder.addCase(loadAuthor.pending, (state: AuthorSliceState, action) => {
      state.loadedAllAuthors = true
      state.error = undefined
    })

    builder.addCase(loadAuthor.rejected, (state, action) => {
      state.loadedAllAuthors = true
      state.error = action.payload
    })

    // Add author
    // @ts-ignore
    builder.addCase(
      addAuthor.fulfilled,
      (state: AuthorSliceState, action: PayloadAction<Author>) => {
        state.authors = [...state.authors, action.payload].sort((a, b) =>
          a.name.eng.localeCompare(b.name.eng),
        )
        state.loadedAllAuthors = true
        state.error = undefined
      },
    )

    builder.addCase(addAuthor.pending, (state: AuthorSliceState, action) => {
      state.loadedAllAuthors = true
      state.error = undefined
    })

    builder.addCase(addAuthor.rejected, (state, action) => {
      state.loadedAllAuthors = true
      state.error = action.payload
    })
  },
})

export const { setAuthor } = authorSlice.actions
export default authorSlice
